import React from 'react';
import { IReviewPhoto } from '@common-types';
import { ArrowRightOutlined } from '@ant-design/icons';
import { IPhotoWithReview } from '../component';

interface TravelerPhotosProps {
    photos: IPhotoWithReview[];
    onPhotoClick: (index: number) => void;
}

export const TravelerPhotos: React.FC<TravelerPhotosProps> = ({ photos, onPhotoClick }) => {
    // Only show up to 5 photos as in the design
    const displayPhotos = photos.slice(0, 5);

    // Logic to select the best version of an image
    const getBestUrl = (photo: IReviewPhoto) => {
        const sorted = [...photo.versions].sort((a, b) => (b.width * b.height) - (a.width * a.height));
        return sorted[0]?.url || '';
    };

    if (!photos || photos.length === 0) return null;

    return (
        <div className="traveler-photos">
            <h3 className="reviews-title">Traveler Photos</h3>
            <div className="photos-grid">
                {displayPhotos.map((item, index) => (
                    <div
                        key={index}
                        className={`photo-item ${index === 0 ? 'large' : ''}`}
                        onClick={() => onPhotoClick(index)}
                    >
                        <img src={getBestUrl(item.photo)} alt={`Traveler photo ${index + 1}`} />
                        {index === 4 && photos.length > 5 && (
                            <div className="see-more-overlay">
                                <div className="arrow-icon">
                                    <ArrowRightOutlined />
                                </div>
                                See more
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
